/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedatasectioncontractor3Inputs */

const en_casedatasectioncontractor3 = /** @type {(inputs: Casedatasectioncontractor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About the contractor`)
};

const pt_casedatasectioncontractor3 = /** @type {(inputs: Casedatasectioncontractor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o empreiteiro`)
};

/**
* | output |
* | --- |
* | "About the contractor" |
*
* @param {Casedatasectioncontractor3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedatasectioncontractor3 = /** @type {((inputs?: Casedatasectioncontractor3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedatasectioncontractor3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedatasectioncontractor3(inputs)
	return pt_casedatasectioncontractor3(inputs)
});
export { casedatasectioncontractor3 as "caseDataSectionContractor" }